import './public-path';


import React from 'react';
import ReactDOM from 'react-dom/client';

import {App} from './App';
import reportWebVitals from './reportWebVitals';

// 开发环境 Mock — 必须在所有其他 import 之前执行
if (process.env.REACT_APP_MOCK === 'true') {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  require('./mocks/setupMocks').setupMocks();
}


// 动态设置 publicPath，保证子应用资源路径正确
// @ts-ignore
if (window.__POWERED_BY_QIANKUN__) {
  // eslint-disable-next-line no-undef
  // @ts-ignore
  __webpack_public_path__ = window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__;
}

/* const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
); */
/* root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); */
// 扩展 Window 接口，声明 Qiankun 的全局变量
interface QiankunWindow extends Window {
  __POWERED_BY_QIANKUN__?: boolean;
  __INJECTED_PUBLIC_PATH_BY_QIANKUN__?: string;
}

// 定义 Qiankun props 类型
interface QiankunProps {
  container?: HTMLElement;
  [key: string]: any;
}

let root: any | null = null;

function render(props: QiankunProps = {}) {
  const { container, ...appProps } = props;
  const rootElement = container
    ? container.querySelector('#root')
    : document.querySelector('#root');
  if (!rootElement) return;
  if (!root) {
    root = ReactDOM.createRoot(rootElement);
  }
  root.render(
    <React.StrictMode>
      <App {...appProps} />
    </React.StrictMode>
  );
}

if (!(window as QiankunWindow).__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  console.log('[kyb] bootstrap');
}

export async function mount(props: QiankunProps) {
  console.log('[kyb] mount', props);
  render(props);
}

export async function unmount(props: QiankunProps) {
  console.log('[kyb] unmount');
  if (root) {
    root.unmount();
    root = null;
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
